/* 
Author:Lamiaa Moustafa
Desc: Routing component
*/
import React from "react";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import ProtectedRoute from "./ProtectedRoute";
import Login from "../views/Login";
import Landing from "../views/Landing";
import ForgotPassword from "../views/ForgotPassword";
import Authentication from "../views/Authentication";
import Faq from "../views/Faq";
import Contact from "../views/Contact";
import NotFound from "../views/NotFound";
import Dashboard from "../views/Dashboard";
import Register from "../views/Register";
import Home from "../views/home";
import AccessControl from "../views/AccessControl";
import ManageAccount from "../views/ManageAccount";
import Layout from "../views/Dashboard/layout";

function Routers() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Landing />}>
          <Route index element={<Login />} />
          <Route path="forgotPassword" element={<ForgotPassword />} />
          <Route path="authentication" element={<Authentication />} />
        </Route>
        
         <Route path="/" element={<Dashboard/>}> 
         <Route path="layout" element={<Layout />} />
         <Route path="/" element={<Home/>}> 
          <Route path="register" element={<Register />} />
          <Route path="accessControl" element={<AccessControl />} />
          <Route path="manageAccount" element={<ManageAccount/>}/>
           <Route path="faq" element={<Faq/>}/>
          </Route>
              <Route path="contact" element={<Contact />}></Route>
          </Route>
        <Route path="*" element={<NotFound />}></Route>
      </Routes>
    </Router>
  );
}

export default Routers;
